import { Injectable, NgZone } from '@angular/core';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { UtilsService } from '../utils/utils.service';
import { DataExchangeService } from '../utils/dataexchange.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {

  //private apiUrl = 'http://localhost:8081/application/api/';

  //private apiUrl = 'http://ka.kaiotee.com:8080/application/api/';

  //private apiUrl = 'https://api.kdc1.kaiotee.com/application/api/';

  private apiUrl = 'https://ka.kaiotee.com/application/api/';

  //docker
  //private apiUrl = 'http://kaioteecore:8081/application/api/';

  key : any;
  headers: any;

  constructor(private http: HttpClient, private utils: UtilsService, 
    private dataexchange: DataExchangeService, private router : Router, private zone : NgZone) {

  }

  ngOnInit() {

  }

  doLogin(key): Observable<any> {

    let loginheader = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Basic ' + key })
    };
    return this.http.get<any>(this.apiUrl + 'version', loginheader)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  checkNetwork(): Observable<any> {

    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.get<any>(this.apiUrl + 'version', this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  getAppVersion(): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.get<any>(this.apiUrl + 'version', this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  shortAverages(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'shortaverages', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }


  longAverages(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'longaverages', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  readingsperdaywindow(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'readingsperdaywindow', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  readings24hours(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'readings24hours', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  readingsPrevious24hours(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'readingsprevious24hours', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  averagesForMonth(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'averagesformonth', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  latestReadings(data): Observable<any> {

    let headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };

    console.log(this.dataexchange.authkey);

    return this.http.post<any>(this.apiUrl + 'latestrawreadings', data, headers)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  latestReadingsForTenant(data): Observable<any> {

    let headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };

    return this.http.post<any>(this.apiUrl + 'dashboardlatestreadings', data, headers)
      .pipe( 
        retry(1),
        catchError(this.handleError)
      )
  }

  latestReadingsForPeerTenants(data): Observable<any> {

    let headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };

    return this.http.post<any>(this.apiUrl + 'dashboardlatestreadingsforpeertenants', data, headers)
      .pipe( 
        retry(1),
        catchError(this.handleError)
      )
  }

  dailySnapshot(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'dailysnapshot', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  latestAlerts(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };

    return this.http.post<any>(this.apiUrl + 'latestdispatchednotifications', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  alertsCountAnalysis(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'notificationscountbytenant', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  outagesCountAnalysis(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'outagecountbytenant', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }


  dailyReports(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'dailyreports', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  tenantMetaData(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'tenantmetadata', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }


  deviceInfo(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'deviceinfo', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  weeklyReports(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'weeklyreports', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

 monthlyReports(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'monthlyreports', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  downloadReport(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'downloadreport', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  emailReport(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'emailreport', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  userInfo(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'userdetails', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  dispatchedNotifications(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'dispatchednotifications', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  last7DaydispatchedNotifications(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'last7daydispatchednotifications', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  alertsTrendingForTenantDomain(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'notificationscounttrendingbytenant', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  last30DayNotificationsByUuid(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'last30daydispatchednotificationsbyuuid', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  last30DayNotificationsCountsByUuid(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'last30daynotificationscountsbyuuid', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  last30DayOutagesCountsByUuid(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'last30dayoutagescountbyuuid', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  peerTenantList(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'peertenantlist', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }


  tenantInfo(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'tenantinfo', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  deviceList(data): Observable<any> {
    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // 
        'Authorization': 'Basic ' + this.dataexchange.authkey
      }) //
    };
    return this.http.post<any>(this.apiUrl + 'devicelist', data, this.headers)
      .pipe(
        retry(0),
        catchError(this.handleError)
      )
  }

  


  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {

      if (error.status == 0) {
        throw new Error("BackendNotAvailable");
      }

    } else {

      if (error.status == 0) {

        throw new Error("BackendNotAvailable");
      }

      if (error.status == 401) {

        this.zone.run(() => this.router.navigate(['/login']));
      }

      if (error.status == 404) {

        throw new Error("ObjectNotFoundError");
      }

      if (error.status == 500) {

        throw new Error("AppConfigError");
      }
    }
    // return an observable with a user-facing error message
    return throwError(
      'Unknown error! Code:' + error.status);
  };
}
